import React from "react";

import styles from './Footer.module.css';
import logo from "../../images/LogoAsl.svg";

export function Footer() {

    return (
        <footer className={styles.footer}>
            <div>&copy; 2025 Tzion MyResult 2025.001.02.13</div>
            <img src={logo} alt="Logo da ASL" />
        </footer>
    );
}